import { render, staticRenderFns } from "./DatabaseSizes.vue?vue&type=template&id=376b7c16&"
import script from "./DatabaseSizes.vue?vue&type=script&lang=js&"
export * from "./DatabaseSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports